<template>
    <div>
        <div v-for="header in headers" :key="header.title">
            <v-card-title>{{ header.title }}</v-card-title>
            <v-card-text class="body-1" v-if="header.body">{{
                header.body
            }}</v-card-text>
            <component
                v-if="header.comp"
                :is="header.comp.name"
                v-bind="{ ...header.comp.props }"
                :class="header.comp.classes"
            />
        </div>
        <v-card-title>RockStars FAQ:</v-card-title>
        <v-expansion-panels v-model="panels" class="soli-round" accordion>
            <v-expansion-panel v-for="FAQ in FAQS" :key="FAQ.question">
                <v-expansion-panel-header class="font-weight-bold">{{
                    FAQ.question
                }}</v-expansion-panel-header>
                <v-expansion-panel-content
                    ><div
                        v-if="FAQ.answer"
                        v-html="FAQ.answer"
                        class="body-1" />
                    <component
                        v-if="FAQ.comp"
                        :is="FAQ.comp.name"
                        v-bind="{ ...FAQ.comp.props }"
                        :class="FAQ.comp.classes"
                /></v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import IndentList from "./IndentList.vue";
import RenderList from "./RenderList.vue";

export default {
    components: {
        RenderList,
        IndentList,
    },
    props: {
        location: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            panels: null,
            locationPrices: [],
        };
    },
    computed: {
        headers() {
            return [
                {
                    title: "Musicologie RockStars",
                    body: `Experience Simply Delightful Music Lessons with Musicologie! We are a premier music education company for ages 6 months through adults. Our programs are specifically designed to make learning and playing music fun for all ages, abilities and instruments.
                        Have you dreamed of playing with a band on stage? Join Musicologie RockStars, our premiere performance program. You’ll learn a mix of contemporary and classic songs practicing with your band once per week. RockStar students meet new friends, are more excited about learning in their private lessons each week and have a blast playing at real venues. It’s a great way to grow as a player in a fast and exciting environment.
                        `,
                },
                {
                    title: "Our Approach to Music Lessons",
                    body: `At Musicologie we know that music lessons are one of the most impactful investments you can make in yourself or in your child. Learning music improves coordination, language, reading and math skills. It nurtures our emotional and cognitive health. Studying an instrument makes our brains bigger and reduces chances of hearing loss and dementia in adults. Plus, it’s fun! We are proud to have a holistic private lesson program that shares music and its benefits with students of all ages and abilities.`,
                },
                /*{
                    title: "Getting Started with RockStars",
                    body: `The first step is to submit your information and we’ll find a band that works for your age, ability and schedule. RockStars is ${this.getPrice(
                        "RockStars Membership"
                    )} per month at Musicologie ${
                        this.location.name
                    }, which includes one weekly 60 minute rehearsal and one 30 minute weekly private lessons.`,
                },*/
            ];
        },
        FAQS() {
            return [
                {
                    question: "How does RockStars work?",
                    answer: "Bands are made up of 4-6 players grouped by instrument and age. Each week, band members have one hour long rehearsal and one 30 minute private lesson. They work on their individual parts in their private lessons and come together during the band rehearsal to practice playing as a group. Then, bands get a chance to show off their skills at studio concerts, community events and shows.",
                },
                {
                    question: `Why should I choose RockStars over traditional private lessons?`,
                    answer: `Playing in a group is a proven way to fast track your playing. Plus, it’s fun! Musicologie RockStars is designed to harness the excitement of playing on stage and use that to make learning music engaging. Our rock band students can’t wait to go home and practice their parts!`,
                },
                {
                    question: "Who is RockStars for?",
                    answer: `RockStars is perfect for students who are beginning to advanced level, age 7 or older and want to perform with a group!`,
                },
                {
                    question: "How do I get started?",
                    answer: `The first step is to submit your information and we’ll find a band that works for your age, ability and schedule.`,
                },
                {
                    hidden: !this.location,
                    question: "What is the pricing?",
                    answer: `RockStars is ${this.getPrice(
                        "RockStars Membership"
                    )} per month at Musicologie ${
                        this.location?.name
                    }, which includes one weekly 60 minute rehearsal and one 30 minute weekly private lessons. We want you to LOVE your experience at Musicologie. If you don’t, we’ll refund your first payment, no questions asked.`,
                },
                {
                    question: "Can a beginner be in RockStars?",
                    answer: `Yes! Our curriculum makes it easy for even a beginner to participate in RockStars.`,
                },
                {
                    question: "Is there a sibling or family discount?",
                    answer: `Yes. There is a 3% discount off your entire invoice if more than one family member is taking lessons. The discount is applied automatically and you'll see it on your monthly invoice.`,
                },
                {
                    question: "What’s Musicologie’s withdrawal policy?",
                    answer: `To withdraw from Musicologie and end automatic billing, all you need to do is fill out the quick form at https://musicologie.com/exit 30 days before your last lesson. Your withdrawal is not processed until you fill out that form. We require 30 days notice, which begins the day that form is received. Your final invoice will be prorated the last 30 days.`,
                },
                {
                    question: `What’s Musicologie’s single lesson or rehearsal cancellation policy?`,
                    answer: `You can cancel or change your weekly private lesson up to 24 hours before your lesson time. If you cancel, that canceled lesson stays on your account and you can reschedule it at any time in the future. Canceled lessons never expire as long as you’re a current student. <br/><br/> Band rehearsals cannot be rescheduled.`,
                },
                {
                    question: "How do I reschedule my lesson?",
                    answer: `Log into your account at Musicologie.com to view your schedule and select any lesson to cancel or change. You can cancel or change up to 24 hours before your lesson.`,
                },
            ].filter((e) => !e.hidden);
        },
    },
    methods: {
        getPrice(product) {
            if (!this.locationPrices.length) return "(...loading)";
            return this.formatUnitAmount(
                this.locationPrices.find((e) => e.name == product).amount
            );
        },
        getLocationPricing() {
            if (!this.location) return;

            axios
                .get(route("stripe.locationPricing"), {
                    params: {
                        location_id: this.location.id,
                    },
                })
                .then((resp) => {
                    this.locationPrices = resp.data;
                });
        },
    },
    mounted() {
        this.getLocationPricing();
    },
};
</script>
